import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Shopify Plus Development for High-Growth Ecommerce Brands in New York
        </h1>

        {/* Description under heading */}
        <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          Mean3, is a leading Shopify Plus company, helping high-growth ecommerce brands scale with enterprise-grade Shopify Plus stores. Our New York Shopify Plus experts combine advanced development, strategic design, and robust integrations to deliver storefronts optimized for speed, stability, and conversion.
        </p>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {/* Card 1 */}
          <div className="bg-[#E42E35] text-white p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
              Scalable Shopify Plus Ecommerce Experiences
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
              As certified Shopify Plus partners, we build ecosystems that support high-volume sales, streamline operations, and enhance customer experiences. From Shopify Plus store development in New York to migrations from platforms like Magento, we create scalable, high-performance infrastructure tailored to your business growth.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#f5f5f5] text-[#373737] p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
             Trusted Shopify Plus Partner For Growth
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
              Growing ecommerce brands choose Mean3 as their Shopify Plus development agency, as we combine strategic design with technical expertise. Our team builds stores prepared for long-term growth and competitive markets, ensuring seamless navigation, secure checkouts, and optimized performance across devices.
            </p>
          </div>
        </div>
      </div>

      {/* Logos row stays same */}
      <div className="w-[90%] flex justify-center items-center section2-container mx-auto">
        <div className="mx-5">
          <img
            className="w-[120px]"
            alt="Awards Logos"
            src="/assets/go-awards-logo.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[97px]"
            alt="Awards Logos"
            src="../../../../assets/award2.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[119px]"
            alt="Awards Logos"
            src="../../../assets/secp-logo.jpg"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[116px]"
            alt="Awards Logos"
            src="/assets/pasha-logo.jpg"
          />
        </div>
      </div>
    </div>
  );
}
